import {getService} from "~/lib/services/services-manager";
import {Notification} from "~/modules/notifications/lib/notification";
import {PublicationOptions} from "~/modules/notifications/lib/publication-options";
import {Recipients} from "~/modules/notifications/lib/recipients";

export const publishNotification = async (notification: Notification, publicationOptions: PublicationOptions, recipients: Recipients) => {
  const service = getService("server-app");
  await service.post(`/notifications/publish`, {notification, publicationOptions, recipients});
};

export type RecipientUser = {
  uuid: string;
  email: string;
}

export const getRecipients = async (recipients: Recipients): Promise<RecipientUser[]> => {
  const service = getService("server-app");
  const response = await service.post(`/notifications/recipients`, {recipients});
  return response.data.users;
};

export const getAllNotificationsForOwner = async (ownerUUID: string, options): Promise<{ notifications: Notification[], total: number }> => {
  const service = getService("server-app");
  const response = await service.post(`/notifications/all/${ownerUUID}`, options);

  return {
    notifications: response.data.notifications.map(data => Notification.fromPayload(data)),
    total: response.data.total
  };
}

export const removeNotification = async (notification: Notification) => {
  const service = getService("server-app");
  await service.delete(`/notifications/${notification.uuid}`);
}

export async function getNotificationContent(notification:Notification){
  const service = getService("server-app");
  const result = await service.get(`/notifications/content/${notification.uuid}`);
  return result.data.content;
}